export enum MutationTypes {
  SET_LOGIN_DIALOG_STATUS = "SET_LOGIN_DIALOG_STATUS",
  SET_CALENDAR_DIALOG_STATUS = "SET_CALENDAR_DIALOG_STATUS",
  SET_ADD_TASK_DIALOG_NAME = "SET_ADD_TASK_DIALOG_NAME",
  SET_IS_ADD_TASK_DIALOG_STATUS = "SET_IS_ADD_TASK_DIALOG_STATUS",
  SET_CHECKLIST_STATUS = "SET_CHECKLIST_STATUS",
  SET_MOBILE_SIDEBAR = "SET_MOBILE_SIDEBAR",
  SET_GOOGLE_TOKEN = "SET_GOOGLE_TOKEN",
  SET_USER_INFO = "SET_USER_INFO",
  SET_LOGIN_DATA = "SET_LOGIN_DATA",
  LOGOUT = "LOGOUT",
  ADD_LABEL = "ADD_LABEL",
  SET_BOOKMARK = "SET_BOOKMARK",
  DELETE_BOOKMARK = "DELETE_BOOKMARK",
  SET_COLUMNS = "SET_COLUMNS",
  SET_STATE = "SET_STATE",
  SET_DRIVE_FILE = "SET_DRIVE_FILE",
  SET_CHECKLIST = "SET_CHECKLIST",
  ADD_CHECKITEM = "ADD_CHECKITEM",
  UPDATE_CHECKLIST = "UPDATE_CHECKLIST",
  DELETE_CHECKLIST = "DELETE_CHECKLIST",
  ADD_TASK = "ADD_TASK",
  EDIT_TASK = "EDIT_TASK",
  DELETE_TASK = "DELETE_TASK",
  ARCHIVE_TASK = "ARCHIVE_TASK",
  SET_ARCHIVE_STATUS = "SET_ARCHIVE_STATUS",
  SET_BACKGROUND_COLOR = "SET_BACKGROUND_COLOR",
  SET_BACKGROUND_IMAGE = "SET_BACKGROUND_IMAGE",
  SET_NOTIFICATION = "SET_NOTIFICATION",
  DELETE_NOTIFICATION = "DELETE_NOTIFICATION",
  SET_LOADING = "SET_LOADING",
  UPDATE_COLUMN = "UPDATE_COLUMN",
  ADD_COMMENT = "ADD_COMMENT",
  EDIT_COMMENT = "EDIT_COMMENT",
  DELETE_COMMENT = "DELETE_COMMENT",
  SEARCH_COLUMNS = "SEARCH_COLUMNS",
  DARK_MODE = "DARK_MODE",
  LIGHT_MODE = "LIGHT_MODE",
}
